module.exports = __webpack_public_path__ + "static/img/recharge_top_bg.40bb19a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/recharge/recharge_top_bg.png
// module id = f3tU
// module chunks = 1